import * as React from 'react';

// PACKAGES
import { useLocation } from 'react-router';

// COMPONENTS
import ErrorMessage from '../../components/ErrorMessage';

interface ProfileErrorTypes {}

const ProfileError: React.FC<ProfileErrorTypes> = ({}) => {
	const location = useLocation();
	const error = location.state.error;

	return (
		<div className="">
			<ErrorMessage message={error} />
		</div>
	);
};

export default ProfileError;
